import apiService from './api';

const SPIN_BASE = '/Spin';

export const spinService = {
  play: async () => {
    return await apiService.post(`${SPIN_BASE}/Play`);
  },

  canSpin: async () => {
    return await apiService.get(`${SPIN_BASE}/CanSpin`);
  },

  getMyCoupons: async () => {
    return await apiService.get(`${SPIN_BASE}/MyCoupons`);
  },

  validateCoupon: async (code) => {
    return await apiService.get(`${SPIN_BASE}/ValidateCoupon`, { code });
  },

  useCoupon: async (code) => {
    return await apiService.post(`${SPIN_BASE}/UseCoupon?code=${encodeURIComponent(code)}`);
  },
};

export default spinService;
